import styled from '@emotion/styled'
import { Card } from '@entrata/portals-common/lib/components'
import Button from 'portal-modules/common/components/Button'

import { StyledName } from 'portal-modules/common/components/card-picker/atoms'
import { underlineFocus } from 'portal-modules/common/components/focus-styles'
import { getEmbeddedViewFlag } from 'portal-modules/common/utils/get-embedded-flag'

export const StyledWrapperDiv = styled('div')`
  width: 100%;
  color: black;

  padding-top: ${({ isSmallScreen }) => (isSmallScreen ? '16px' : '40px')};
`

export const StyledInfoP = styled('p')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.secondary.base : theme.mode.text_color};
  font-family: inherit;
  font-size: 15px;
  margin: 0 0 32px;
  width: ${({ isSmallScreen }) => (isSmallScreen ? '100%' : '85%')};
`

export const StyledH3 = styled('h3')`
  font-weight: bold;
  font-size: 21px;
  margin: 0 0 16px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.gray.dark};

  @media screen and (min-width: 1024px) {
    font-weight: 600;
    font-size: 15px;

    &:not(:first-child) {
      margin-top: 40px;
    }
  }
`

export const StyledHeaderButton = styled(Button)`
  width: 100%;
  text-align: center;
  display: inline-block;
  background-color: ${({ theme }) =>
    getEmbeddedViewFlag() && theme.button_primary.background};
  color: ${({ theme }) => getEmbeddedViewFlag() && theme.embedded.button_text};
`

export const StyledButton = styled('button')`
  border: none;
  text-align: left;
  background: none;
  font-size: 16px;
  padding-top: 8px;
  letter-spacing: 0.248px;
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.embedded.button_text : theme.secondary.base};
`

export const StyledHeaderP = styled('p')`
  width: max-content;
  font-style: italic;
  font-family: inherit;
  margin: 0;
  font-size: 13px;
  padding: 16px 0 0;
  color: ${({ isSmallScreen, theme }) =>
    getEmbeddedViewFlag()
      ? theme.primary.base
      : (isSmallScreen || theme.mode.isDark)
      ? theme.white.base
      : theme.black.base};
  position: ${({ isSmallScreen }) => (isSmallScreen ? 'static' : 'inherit')};
`

export const StyledCardFields = styled('div')`
  padding: 16px 0 16px 0;
`

export const StyledCard = styled(Card)`
  opacity: 0.8;
  cursor: pointer;
  border-radius: 8px;
  flex-basis: calc((10% - 8px));
  font-family: ${({ theme }) => theme.fonts.body};
  background-color: ${({ theme }) => getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.gray.highlight};
  border: 1px solid ${({ theme }) => theme.gray.light};

  ${({ isSelected, theme }) =>
    isSelected &&
    `
      border-color: ${theme.primary.base};
      background-color: ${getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.white.base };
  `};
  ${({ isSmallScreen }) =>
    isSmallScreen
      ? `
          padding: 16px 16px 20px 16px;
        `
      : `
          text-align: left;
          height: 130px;
          padding: 12px;
        `};

    @media only screen and (max-width: 360px) {
      min-width: 220px;
  }
`

export const StyledUl = styled('ul')`
  padding-left: 0;
  list-style: none;
  max-width: 768px;
  margin: ${({ noMargin }) => !noMargin && '32px 0'};
`

export const StyledNameMobile = styled(StyledName)`
  text-align: left;
  font-size: 16px;

  @media only screen and (min-width: 400px) {
    font-size: 16px;
  }
`

export const StyledContent = styled('div')`
  height: 40px;
`

export const StyledCCMonthYear = styled('div')`
  font-style: italic;
  font-size: 9px;
  padding-top: 6px;
  color: ${({ theme }) => theme.primary.base};

  @media only screen and (min-width: 400px) {
    font-size: 9px;
    color: ${({ theme }) => theme.primary.base};
  }
`

export const StyledDiv = styled('div')`
  color: ${({ theme }) =>
    getEmbeddedViewFlag() ? theme.primary.base : theme.mode.isDark ? theme.mode.text_color : theme.black.base};
  line-height: 1.4;
  font-style: italic;
  font-size: 15px;
  padding: 4.8px 0 16px 0;
`

export const StyledAddCardButton = styled(Button)`
  ${({ isSmallScreen, theme }) =>
    !isSmallScreen
      ? `
      height: 100%;
      cursor: pointer;
      font-weight: 700;
      text-align: center;
      text-decoration: none;
      justify-content: center;
      background-color: ${getEmbeddedViewFlag() ? theme.embedded.foreground_color : theme.mode.isDark
                ? theme.mode.card_background_color : theme.white.base };
      transition: all 250ms ease-out;
      margin: 6.4px;
      font-size: 16px;
      border-radius: 8px;
      padding: 48px 48px 56px 40px;
      color: ${theme.secondary.base};
      font-family: ${({ theme }) => theme.fonts.body};
      border: 1px solid ${({ theme }) => theme.secondary.base};
      ${underlineFocus}
    `
      : getEmbeddedViewFlag()
      ? `margin-top: 16px;
        background-color:  ${theme.button_primary.background};
        color:  ${theme.embedded.button_text};`
      : `margin-top: 16px;`}
`
export const StyledSaveButton = styled(Button)`
  margin: 24px 0;
`

export const StyledDivContainer = styled('div')`
  margin: 0 40px;

  @media only screen and (max-width: 400px) {
    margin: 24px 16px;
  }
`
